var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('div',{staticClass:"timeValue"},[_vm._v(_vm._s(_vm.currentTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }